// components/ClaimRow.jsx
import React from "react";
import ClaimNameCell from "./tds/ClaimNameCell";
import UploadedBillingCell from "./tds/UploadedBillingCell";
import UploadMandateCell from "./tds/UploadMandateCell";
import StatusCell from "./tds/StatusCell";
import ActionsCell from "./tds/ActionsCell";
import Amount from "./tds/Amount";
const ClaimRow = ({
  claim,
  uploadedFiles,
  handleFileUpload,
  handleSubmitt,
  handleStart,
  handleViewClick,
  getStatusBadge,
  handleChatClick,
  unread

}) => {
  return (
    <tr key={claim._id}>
      <ClaimNameCell claim={claim} />
      <UploadedBillingCell claim={claim} />
      {/* <UploadMandateCell
        claim={claim}
        uploadedFiles={uploadedFiles}
        handleFileUpload={handleFileUpload}
      /> */}
      <Amount claim={claim} />
      <StatusCell claim={claim} getStatusBadge={getStatusBadge} />
      <ActionsCell
        claim={claim}
        uploadedFiles={uploadedFiles}
        handleSubmitt={handleSubmitt}
        handleStart={handleStart}
        handleViewClick={handleViewClick}
        handleChatClick={handleChatClick}
        unread={unread}

      />
    </tr>
  );
};

export default ClaimRow;
